import React from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';
import ToolTip from '../ToolTip';
import { getLevelAdvantages, getLevelAddedAdvantages } from '../../helpers/advantages.js';

const getLevelCoefficient = (level) => {
    switch (level) {
    case 'Silver':
        return '1';
    case 'Gold':
        return '+20%';
    case 'Platinum':
        return '+30%';
    default:
        return '';
    }
};

const getLevelName = (level) => {
    switch (level) {
    case 'Silver':
        return 'Меркурий';
    case 'Gold':
        return 'Сатурн';
    case 'Platinum':
        return 'Юпитер';
    default:
        return '';
    }
};

const getLevelAdvantagesFunction = (period, level) => {
    if (period === 'currentPeriod') return getLevelAdvantages(level);
    return getLevelAddedAdvantages(level);
};

const UserLevelTooltip = ({ children, period, level, requirements }) => (
    <ToolTip
        content={
            <div className={styles.UserLevelTooltipContent}>
                {(period === 'nextPeriod') && (
                    <div
                        className={cn(styles.UserLevelTooltipContentItem, styles.UserLevelTooltipContentItem__NextLevel)}>
                        {requirements.isAchieved
                            ? <div className={styles.UserLevelTooltipContentItem__NextLevelCompleted}>
                                <span>{'Уровень'} </span><span>{getLevelName(level)} </span><span>{'пройден'} </span>
                            </div>
                            : <>
                                <div className={styles.UserLevelTooltipContentItem__NextLevelTitle}>
                                    {`До уровня ${getLevelName(level)}:`}
                                </div>
                                <div className={styles.UserLevelTooltipContentItem__NextLevelConditions}>
                                    <div className={styles.UserLevelTooltipContentItem__NextLevelConditionsCard}>
                                        {requirements.iszhNszh !== 0 && (
                                            <div
                                                className={styles.UserLevelTooltipContentItem__NextLevelConditionsCard__Policies}>
                                                {`${requirements.iszhNszh} НСЖ и ИСЖ совокупно`}
                                            </div>
                                        )}
                                        {requirements.pds !== 0 && (
                                            <div
                                                className={styles.UserLevelTooltipContentItem__NextLevelConditionsCard__Policies}>
                                                {`${requirements.pds} ПДС`}
                                            </div>
                                        )}
                                        {requirements.premiumRub !== 0 && (
                                            <div
                                                className={styles.UserLevelTooltipContentItem__NextLevelConditionsCard__Premium}>
                                                {/* eslint-disable-next-line no-irregular-whitespace */}
                                                {`либо суммарная премия ${requirements.premiumRub.toLocaleString()} руб.`}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                )}
                <div
                    className={cn(styles.UserLevelTooltipContentItem, styles.UserLevelTooltipContentItem__Coefficient)}>
                    <div className={styles.UserLevelTooltipContentItem__CoefficientTitle}>
                        {'Коэффициент начисления уралкоинов'}
                    </div>
                    <div className={styles.UserLevelTooltipContentItem__CoefficientPercent}>
                        <div
                            className={level === 'Silver' ? styles.UserLevelTooltipContentItem__CoefficientPercentNumber : styles.UserLevelTooltipContentItem__CoefficientPercentCard}>
                            {getLevelCoefficient(level)}
                        </div>
                    </div>
                </div>
                <div
                    className={cn(styles.UserLevelTooltipContentItem, styles.UserLevelTooltipContentItem__LevelAdvantages)}>
                    <div className={styles.UserLevelTooltipContentItem__LevelAdvantagesTitle}>
                        {period === 'currentPeriod' ? 'Доступно на уровне:' : 'Дополнительно получите:'}
                    </div>
                    <div className={styles.UserLevelTooltipContentItem__LevelAdvantagesList}>
                        <ul>
                            {getLevelAdvantagesFunction(period, level).map((advantageItem, index) => (
                                <li key={index}>{advantageItem}</li>))}
                        </ul>
                    </div>
                </div>
            </div>
        }
        trigger='mouseenter focus'
        placement='bottom'>
        {children}
    </ToolTip>
);

export default UserLevelTooltip;
